import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import icons from "../constants/icons.ts";

const HeroSlider = ({ slides, interval = 7000 }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % slides.length);
    }, interval);

    return () => clearInterval(timer);
  }, [interval, slides.length]);

  const goPrev = () => {
    setActiveIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const goNext = () => {
    setActiveIndex((prev) => (prev + 1) % slides.length);
  };

  return (
    <section className="relative w-full overflow-hidden h-[620px] md:h-[720px] lg:h-[760px]">
      <div className="relative h-full">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${
              index === activeIndex ? "opacity-100 z-10" : "opacity-0 z-0"
            }`}
          >
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black bg-opacity-40"></div>
            <div className="absolute inset-0 flex flex-col items-start justify-center px-6 sm:px-10 md:px-20 lg:px-24 text-white">
              <span className="inline-block bg-primary bg-opacity-95 text-black px-4 py-2 rounded-full text-sm font-rubik font-medium uppercase tracking-[0.2em] mb-4">
                {slide.badge}
              </span>
              <h1 className="font-rubik font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl max-w-3xl leading-tight mb-6">
                {slide.title}
              </h1>
              <p className="font-rubik font-light text-base sm:text-lg md:text-xl max-w-2xl mb-8">
                {slide.subtitle}
              </p>
              {slide.cta && (
                <Link
                  to={slide.ctaLink}
                  className="btn-primary inline-flex items-center gap-2"
                >
                  {slide.cta}
                  <i className={icons.actions.arrowRight}></i>
                </Link>
              )}
            </div>
          </div>
        ))}

        <div className="absolute bottom-8 left-1/2 z-30 flex -translate-x-1/2 items-center gap-3 rounded-full bg-white/20 px-4 py-3 shadow-xl backdrop-blur-md">
          <button
            onClick={goPrev}
            className="flex h-12 w-12 items-center justify-center rounded-full bg-white text-secondary shadow-md transition-colors hover:bg-primary hover:text-white focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-transparent"
            aria-label="Previous slide"
          >
            <i className={icons.actions.chevronLeft}></i>
          </button>

          <button
            onClick={goNext}
            className="flex h-12 w-12 items-center justify-center rounded-full bg-white text-secondary shadow-md transition-colors hover:bg-primary hover:text-white focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-transparent"
            aria-label="Next slide"
          >
            <i className={icons.actions.chevronRight}></i>
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSlider;
